{
  "voucherType.oneTimeUse": "一次性兌換券",
  "voucherType.multiUse": "多次使用兌換券",
  "voucher.badge.vouchersForRewards": "獎勵",
  "voucher.badge.vouchersForFree": "免費",
  "voucher.badge.vouchersForPoints": "點數",
  "voucher.badge.vouchersAsCashback": "現金回饋",
  "voucherOverviewPage.tabs.vouchersForRewards": "獎勵兌換券",
  "voucherOverviewPage.tabs.vouchersForFree": "免費兌換券",
  "voucherOverviewPage.tabs.vouchersForPoints": "點數兌換券",
  "voucherOverviewPage.tabs.vouchersAsCashback": "現金回饋兌換券",
  "voucherOverviewPage.card.activeAndConnectedTooltip.rewards": "集區為啟用中，並連接至下列行動/福利：<br/>。",
  "voucherOverviewPage.card.activeAndConnectedTooltip.tiers": "集區為啟用中，並在忠誠錢包/API 中顯示下列層級的優惠：<br/>",
  "voucherOverviewPage.card.readyToConnectTooltip.rewards": "集區準備連接至行動和福利。",
  "voucherOverviewPage.card.readyToConnectTooltip.tiers": "集區準備使用，但優惠未啟用。若要啟用優惠，請選擇您要包含兌換券的層級。",
  "voucherOverviewPage.card.inactiveTooltip": "若要啟用此獎勵，請完成定義兌換券設定。",
  "voucherOverviewPage.card.expiredTooltip": "集區或兌換券有效性已過期，請更新代碼和有效性以自動重新啟用集區。",
  "voucherOverviewPage.card.emptyTooltip": "集區沒有代碼，請更新代碼以自動重新啟用集區。",
  "voucherOverviewPage.card.connectedTo": "已連接至",
  "voucherOverviewPage.createNew.vouchersAsCashback": "建立兌換券區",
  "voucherOverviewPage.createNew": "建立兌換券區",
  "voucherOverviewPage.notification.vouchersForRewards.learnMoreLinkText": "深入瞭解",
  "voucherOverviewPage.notification.vouchersForRewards": "若要支援獎勵優惠，請先建立兌換券區。然後，您可將集區連接至行動和福利。{learnMoreLink}。",
  "voucherOverviewPage.notification.vouchersForPoints.learnMoreLinkText": "深入瞭解",
  "voucherOverviewPage.notification.vouchersForPoints": "若要支援兌換優惠，請先建立兌換券區。然後，您可將集區連接至忠誠錢包以支援兌換優惠。{learnMoreLink}。",
  "voucherOverviewPage.notification.vouchersForFree.learnMoreLinkText": "深入瞭解",
  "voucherOverviewPage.notification.vouchersForFree": "在連接至忠誠錢包的集區中管理免費兌換券以支援免費優惠。{learnMoreLink}。",
  "voucherOverviewPage.notification.vouchersAsCashback.learnMoreLinkText": "深入瞭解",
  "voucherOverviewPage.notification.vouchersAsCashback": "現金回饋兌換券會自動傳送至符合定義消費需求的成員，系統將根據您上傳的成員購買資料計算累計消費。{learnMoreLink}。",
  "voucherOverviewPage.title": "兌換券",
  "voucherOverviewPage.card.deleteDialog.headline": "您確定要刪除此集區嗎？",
  "voucherOverviewPage.card.deleteDialog.content": "刪除此集區後，便會永久刪除設定和上傳的代碼。",
  "voucherOverviewPage.card.subTitle.poolExpration": "集區到期：",
  "voucherOverviewPage.card.subTitle.voucherValidity": "兌換券有效性：",
  "voucherOverviewPage.card.subTitle.voucherValidity.unlimited": "無限制",
  "voucherOverviewPage.card.subTitle.voucherSingle": "兌換券",
  "voucherOverviewPage.filters.search.label": "搜尋",
  "voucherOverviewPage.filters.status.label": "狀態",
  "voucherOverviewPage.filters.voucherType.label": "兌換券類型",
  "voucher.validity.defaultMessage": "驗證兌換券代碼時發生錯誤，請稍後再試一次。",
  "voucher.duplicate.voucher.namePrefix": "下列項目的副本： ",
  "rewardSetupRedemption.notification.vouchersForFree": "根據定義的層級和日期，向成員顯示優惠。如果沒有有效的兌換券或啟用集區，則無法啟用優惠。",
  "rewardSetupRedemption.notification.vouchersForPoints": "定義此兌換券區的點數值和成員的兌換優惠。選擇層級且集區為啟用中後，便會立即在忠誠錢包中向成員顯示優惠。",
  "rewardSetupRedemption.notification.vouchersAsCashback": "定義現金回饋兌換券值。僅所選市場和層級中的成員可根據累計消費獲得現金回饋兌換券。",
  "rewardSetup.title.new": "新兌換券區",
  "rewardSetup.multiLangPopupTitle": "以語言為基礎的 URL",
  "rewardSetup.confirmSubmitMessage": "選擇 [新增至集區] 以將新代碼儲存在集區中，並完成上傳。",
  "rewardSetupPoolSettings.notification.cashback": "根據定義的規則和限制，此兌換券區支援現金回饋方案。您僅可為現金回饋方案定義一個兌換券區。",
  "rewardSetupPoolSettings.title": "一般設定",
  "rewardSetupPoolSettings.reward.name.label": "集區名稱",
  "rewardSetupPoolSettings.reward.name.tooltip": "在將此集區連接至福利和行動時要使用的集區內部名稱。",
  "rewardSetupPoolSettings.voucherType.label": "兌換券類型",
  "rewardSetupPoolSettings.isRemoveOnUse.label": "成員使用兌換券後，自動刪除該兌換券",
  "rewardSetupPoolSettings.isRemoveOnUse.tooltip": "僅當您在銷售資料中包含欄位 s_coupon，自動刪除兌換券才會運作。",
  "rewardSetupPoolSettings.voucherName.label": "兌換券名稱",
  "rewardSetupPoolSettings.voucherName.tooltip": "輸入向成員顯示的兌換券名稱。",
  "rewardSetupPoolSettings.voucherIcon.label": "兌換券圖示",
  "rewardSetupPoolSettings.voucherIcon.selectIconText": "新增至兌換券",
  "rewardSetupPoolSettings.voucherIcon.tooltip": "選擇向成員顯示的圖示。",
  "rewardSetupPoolSettings.blockExternalLink.url.label": "外部 URL",
  "rewardSetupPoolSettings.blockExternalLink.url.tooltip": "您可新增 URL 以從忠誠錢包中的兌換券直接連結至頁面。",
  "rewardSetupPoolSettings.blockExternalLink.text.label": "URL 內文",
  "rewardSetupPoolSettings.blockExternalLink.text.tooltip": "輸入要在此 URL 上顯示的內文，該內文會向忠誠錢包中的成員顯示。",
  "rewardSetupPoolSettings.voucherValue.label": "兌換券值",
  "rewardSetupPoolSettings.voucherValue.tooltip": "如果您將值指派給此兌換券，則將使用此值計算投資報酬率，並追蹤成員在忠誠錢包中擁有的金額優惠。",
  "rewardSetupRedemptionValue.valueInPointsHeaderToolTip.free": "選擇您要提供此免費兌換券的層級。",
  "rewardSetupRedemptionValue.valueInPointsHeaderToolTip.cashback": "選擇您要提供現金回饋兌換券的層級，請定義每個層級在取得現金回饋兌換券所需的消費門檻值。",
  "rewardSetupRedemptionValue.valueInPointsHeaderToolTip.points": "選擇您要提供點數兌換券的層級，請定義每個層級在取得點數兌換券所需的點數數量。",
  "rewardSetupRedemptionValue.redemptionMessageTooltip.free": "輸入要在忠誠錢包中顯示的兌換券優惠訊息。",
  "rewardSetupRedemptionValue.redemptionMessageTooltip.points": "輸入要在忠誠錢包中顯示的兌換券優惠訊息。內文欄位包含每個層級定義的點數值權杖。",
  "rewardSetupRedemptionValue.points": "點數",
  "rewardSetupRedemptionValue.notification.cashback": "啟用現金回饋方案後，您便可在定義的市場和層級中使用此方案。現金回饋優惠會顯示在忠誠錢包中，成員可根據累計消費取得現金回饋兌換券。<br>。僅當方案為啟用中，成員才可累計現金回饋。停用方案後，現金回饋會從錢包移除，而成員將停止取得現金回饋。如果方案再次啟用，則會儲存成員累計現金回饋金額。",
  "rewardSetupRedemptionValue.offerTitle.cashback": "現金回饋優惠",
  "rewardSetupRedemptionValue.offerTitle.other": "兌換優惠",
  "rewardSetupRedemptionValue.targetMarkets.cashback.label": "現金回饋目標鎖定",
  "rewardSetupRedemptionValue.targetMarkets.other.label": "優惠目標鎖定",
  "rewardSetupRedemptionValue.targetMarkets.cashback.tooltip": "選擇您要提供此優惠的市場。",
  "rewardSetupRedemptionValue.targetMarkets.other.tooltip": "選擇此優惠的目標市場。此優惠僅在目標市場忠誠錢包中有效，並顯示於其中。",
  "rewardSetupRedemptionValue.offerMessage.title": "優惠訊息 ",
  "rewardSetupRedemptionValue.offerMessage.tooltip": "顯示訊息格式",
  "rewardSetupRedemptionValue.blockExternalLink.url.label": "外部 URL",
  "rewardSetupRedemptionValue.blockExternalLink.url.tooltip": "您可新增 URL 以從忠誠錢包中的兌換券直接連結至頁面。",
  "rewardSetupRedemptionValue.blockExternalLink.text.tooltip": "輸入要在此 URL 上顯示的內文，其將向忠誠錢包中的成員顯示。",
  "rewardSetupRedemptionValue.blockExternalLink.text.label": "URL 內文",
  "rewardSetupUpload.previewPoolSampleCodes.title": "預覽兌換券代碼",
  "rewardSetupUpload.popupUploadError.title": "上傳檔案時發生錯誤。",
  "rewardSetupUpload.popupResetPool.title": "您確定要刪除集區代碼嗎？",
  "rewardSetupUpload.popupResetPool.notice": "刪除集區後，便會刪除現有代碼。",
  "rewardSetupUpload.refillReminder.label": "儲值提醒",
  "rewardSetupUpload.refillReminder.tooltip": "輸入要對集區中剩餘有效代碼觸發儲值提醒的數量。",
  "rewardSetupUpload.popupUploadError.content": "上傳檔案時發生錯誤。\n由於發生下列錯誤，因此無法進行上傳：",
  "rewardSetupUpload.sampleCodes.content": "這是此集區中的某些兌換券代碼名單，請使用這些代碼以檢查是否上傳正確的集區。",
  "rewardSetupUpload.poolStatus.codeStatusLabel": "代碼狀態",
  "rewardSetupUpload.poolStatus.preview.tooltip": "預覽代碼",
  "rewardSetupUpload.poolStatus.delete.tooltip": "刪除代碼",
  "rewardSetupUpload.poolStatus.table.header.currentlyAvailable": "可用代碼",
  "rewardSetupUpload.poolStatus.table.header.numUploads": "上傳數量",
  "rewardSetupUpload.poolStatus.table.header.totalCodes": "上傳代碼總計",
  "rewardSetupUpload.poolStatus.table.header.firstUplaod": "首次上傳",
  "rewardSetupUpload.poolStatus.table.header.lastUplaod": "最後上傳",
  "rewardSetupUpload.poolStatus.table.header.poolStatus": "集區狀態",
  "rewardSetupUpload.pendingUpload.table.header.fileName": "檔案名稱",
  "rewardSetupUpload.pendingUpload.table.header.fileSize": "檔案大小",
  "rewardSetupUpload.pendingUpload.table.header.numCodes": "代碼數量",
  "rewardSetupUpload.newUplad.learnMore": "深入瞭解",
  "rewardSetupUpload.newUplad.contentLink": "深入瞭解",
  "rewardSetupUpload.newUplad.notification.content": "如果您將新代碼上傳至現有集區，請確保設定的有效性與現有代碼相符。{contentLink}",
  "rewardSetupUpload.newUplad.label": "上傳代碼",
  "rewardSetupUpload.newUplad.placeholder": "選擇要上傳的 CSV 檔案。",
  "rewardSetupUpload.newUplad.tooltip": "代碼名單必須為 CSV 檔案，檔案大小上限為 15 MB。",
  "rewardSetupUpload.newUplad.sampleCsv": "範例 CSV 範本",
  "rewardSetupUpload.newUplad.sampleLink": "範例 CSV 範本",
  "rewardSetupUpload.newUplad.downloadSample": "下載 {sampleLink} 作為上傳名單的範本使用。",
  "rewardSetupUpload.deleteDialog.headline": "您確定要刪除此檔案嗎？",
  "rewardSetupUpload.deleteDialog.content": "刪除此檔案後，便無法將代碼新增至集區。",
  "rewardSetupUpload.error.upload": "嘗試上傳檔案時發生錯誤。",
  "rewardSetupUpload.error.fileSize": " 檔案大小大於 15MB，請上傳較小的檔案。",
  "rewardSetupUpload.error.fileEmpty": "上傳的檔案為空白，請嘗試上傳包含資料的檔案。",
  "rewareSetupValidity.title": "集區和兌換券",
  "rewareSetupValidity.poolValidity.label": "集區有效性",
  "rewareSetupValidity.poolValidity.tooltip": "選擇此集區中已上傳代碼的有效期間。個別成員的有效期間視成員取得兌換券的日期而定。{urlLink}",
  "rewareSetupValidity.voucherValidityType.label": "兌換券有效性選項：",
  "rewareSetupValidity.voucherValidityType.tooltip": "選擇此集區中兌換券的有效性類型。兌換券過期時，便會從忠誠錢包移除存取。",
  "rewareSetupValidity.voucherValidity.label": "選擇有效性",
  "rewareSetupValidity.voucherValidity.tooltip": "選擇自成員取得兌換券日期起的兌換券有效期間。兌換券過期時，便會從忠誠錢包移除存取。",
  "rewareSetupValidity.voucherExpiryDate.label": "選擇兌換券到期",
  "rewareSetupValidity.limitValue.label": "優惠數量",
  "rewareSetupValidity.limitValue.tooltip": "輸入每個成員可從此集區兌換兌換券的次數。成員達到次數後，便不會再看到此兌換券。",
  "rewareSetupValidity.offerRestrictions.title": "優惠限制",
  "rewareSetupValidity.offerRestrictions.tooltip.rewardActive": "輸入每個成員可在定義期間兌換此優惠兌換券的次數。啟用新優惠後，也會重設和重新啟用限制。",
  "rewareSetupValidity.offerRestrictions.tooltip.rewardNotActive": "選擇每個成員可在定義期間兌換此優惠兌換券的次數。",
  "rewareSetupValidity.redemption.limitType.label": "優惠限制",
  "rewareSetupValidity.redemption.limitType.tooltip": "限制在狀態和有效性設定中定義的期間內有效。啟用新優惠後，也會重設和重新啟用限制。",
  "rewareSetupValidity.offerStatusAndValidity.title": "優惠狀態和有效性",
  "rewareSetupValidity.offerStatusAndValidity.tooltip": "選擇優惠狀態和此優惠在忠誠錢包中可供成員使用的期間。",
  "rewareSetupValidity.rewardModifyOrNew.tooltip": "選擇優惠狀態和此優惠在忠誠錢包中可供成員使用的期間。",
  "rewareSetupValidity.rewardModifyOrNew.label": "優惠狀態和有效性",
  "rewareSetupValidity.poolDateValidity.valid.alertText": "兌換券到期",
  "rewareSetupValidity.poolDateValidity.invalid.alertText": "無效集區有效性",
  "rewareSetupValidity.poolDateValidity.valid.alertMessage": "已設定集區有效性。您可在 {datetext} 上取得此集區中的最後兌換券 (集區有效性 - 兌換券有效性 - 獎勵分配延遲)。我們將在集區過期前的 14 天向您傳送上傳新代碼的提醒。請確保上傳新代碼並更新集區有效性，否則集區會自動中斷連接，成員便無法取得或兌換兌換券。",
  "rewareSetupValidity.poolDateValidity.invalid.alertMessage": "輸入早於集區有效性日期且也包含獎勵分配延遲時間的兌換券有效性日期。{urlLink}",
  "validity.voucherValidity.duration.presence": "輸入大於零的數字作為兌換券有效性日期。",
  "validity.voucherValidity.duration.numericality.notInteger": "輸入大於零的數字作為兌換券有效性日期。",
  "validity.voucherValidity.duration.numericality.notGreaterThan": "輸入大於零的數字作為兌換券有效性日期。",
  "validity.voucherValidity.voucherExpiryDate": "輸入早於集區有效性日期的兌換券到期日期。",
  "validity.voucherValidity.voucherExpiryDate.FIXED_DATE": "輸入早於兌換券到期日期的優惠結束日期。",
  "validity.voucherValidity.voucherExpiryDate.LIMITED_FROM_EARN": "輸入早於兌換券到期日期的優惠結束日期。",
  "validity.voucherValidity.voucherExpiryDate.other": "輸入早於集區有效性日期的優惠結束日期。",
  "rewardValidator.poolSettingsStepConstraints.voucherName.presence": "輸入兌換券名稱。",
  "rewardValidator.poolSettingsStepConstraints.name.presence": "輸入集區名稱。",
  "rewardValidator.poolSettingsStepConstraints.name.exclusionIgnoreCase": "此名稱已存在，請輸入唯一名稱。",
  "rewardValidator.redemption.targetMarkets.presence": "輸入兌換目標市場。",
  "rewardValidator.rvalidity.poolValidity.presence": "輸入集區有效性日期。",
  "rewardValidator.validity.voucherValidity.duration.messageRequired": "輸入大於零的數字作為兌換券有效性日期。",
  "rewardValidator.validity.voucherValidity.duration.messageHigherThanZero": "輸入大於零的數字作為兌換券有效性日期。",
  "rewardValidator.validity.voucherExpiryDate.presence": "輸入兌換券到期日期。",
  "rewardValidator.validity.voucherExpiryDate.voucherExpiryDate": "輸入早於集區有效性日期的兌換券到期日期。",
  "rewardValidator.validity.refillReminder.presence": "輸入大於或等於 0 的數字作為儲值提醒。",
  "rewardValidator.validity.refillReminder.numericality.notInteger": "輸入大於或等於 0 的數字作為儲值提醒。",
  "rewardValidator.validity.refillReminder.numericality.notGreaterThan": "輸入大於或等於 0 的數字作為儲值提醒。",
  "voucherOverviewPage.card.scheduledTooltip": "集區已準備好可供使用，優惠已排程於：{text}。",
  "voucherDashboard.overviewLinkText.vouchersForRewards": "移至獎勵兌換券",
  "voucherDashboard.overviewLinkText.vouchersForPoints": "移至點數兌換券",
  "voucherDashboard.overviewLinkText.vouchersForFree": "移至免費兌換券",
  "voucherDashboard.overviewLinkText.vouchersAsCashback": "移至現金回饋兌換券",
  "voucherDashboard.downloadVoucherDataButton.label": "下載兌換券資料",
  "voucherDashboard.downloadVoucherDataButton.tooltipAsReward": "僅提供自 9 月 9 日起的資料。",
  "voucherDashboard.editButton.label": "編輯兌換券",
  "voucherDashboard.voucherCreatedAt": "兌換券區建立於 {time}",
  "voucherDashboard.vouchesAttachedWidget.title": "已附加兌換券",
  "voucherDashboard.vouchesAttachedWidget.kpiTitle": "已附加兌換券總數量",
  "voucherDashboard.vouchesAttachedWidget.kpiTooltip": "已指派合格成員的兌換券數量。",
  "voucherDashboard.vouchesAttachedWidget.chartTotalMetric": "總計",
  "voucherDashboard.vouchesDistributedWidget.title": "公開的兌換券代碼",
  "voucherDashboard.vouchesDistributedWidget.kpiTitle": "公開的兌換券總數量",
  "voucherDashboard.vouchesDistributedWidget.kpiTooltip": "向忠誠成員顯示的兌換券代碼數量",
  "voucherDashboard.vouchesDistributedWidget.chartTotalMetric": "總計",
  "voucherOverviewPage.card.subTitle.availableCoupons": "可用 {text}",
  "voucher.redemption.message.text.vouchersAsCashback": "為每 {text} 的費用賺取現金回饋兌換券"
}
